import { TermsCategory } from '@/api/terms.types';
import usePreservedCallback from '../../../hooks/react/usePreservedCallback';
import { useTermsList } from './useTerms';
import useTermsMutation from '../../../queries/hooks/useTermsMutation';

export default function useUpdateTermsAgreement() {
  const currentTerms = useTermsList();
  const { mutateAsync: update } = useTermsMutation();

  return usePreservedCallback(async (value: Record<TermsCategory, boolean>) => {
    const next = currentTerms.map((terms) => ({
      ...terms,
      isAgreed: value[terms.category] ?? terms.isAgreed,
    }));

    await update(next);
  });
}
